window.theme.component('offer-engagement', root => {
	const nonce = window.config && window.config.pechincha_engagement_nonce ? window.config.pechincha_engagement_nonce : '';

	function postForm(action, fields) {
		const body = new URLSearchParams();
		body.append('action', action);
		body.append('nonce', nonce);
		Object.entries(fields).forEach(([k, v]) => body.append(k, String(v)));
		return fetch(`${config.ajax_url}`, {
			method: 'POST',
			credentials: 'same-origin',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			body: body.toString(),
		}).then(r => r.json());
	}

	root.addEventListener('click', e => {
		const voteBtn = e.target.closest('.js-offer-vote');
		if (voteBtn && root.contains(voteBtn)) {
			e.preventDefault();
			const postId = parseInt(voteBtn.dataset.postId, 10) || 0;
			let vote = parseInt(voteBtn.dataset.vote, 10);
			if (voteBtn.classList.contains('is-active')) {
				vote = 0;
			}
			postForm('pechincha_vote_offer', { post_id: postId, vote }).then(res => {
				if (!res.success || !res.data) {
					console.error(res.data && res.data.message ? res.data.message : 'Vote failed');
					return;
				}
				const scoreEl = root.querySelector('.js-offer-score');
				if (scoreEl) {
					scoreEl.textContent = String(res.data.score);
				}
				root.querySelectorAll('.js-offer-vote').forEach(btn => {
					const v = parseInt(btn.dataset.vote, 10);
					const active = res.data.user_vote === v && v !== 0;
					btn.classList.toggle('is-active', active);
					btn.setAttribute('aria-pressed', active ? 'true' : 'false');
				});
			});
			return;
		}

		const reportBtn = e.target.closest('.js-offer-report');
		if (reportBtn && root.contains(reportBtn)) {
			e.preventDefault();
			if (!window.confirm('Denunciar esta oferta como inválida?')) {
				return;
			}
			const postId = parseInt(reportBtn.dataset.postId, 10) || 0;
			postForm('pechincha_report_offer', { post_id: postId }).then(res => {
				if (!res.success) {
					console.error(res.data && res.data.message ? res.data.message : 'Report failed');
					return;
				}
				const wrap = reportBtn.parentElement;
				if (wrap) {
					wrap.innerHTML = '<span class="offer-engagement__reported">Você já denunciou esta oferta.</span>';
				}
				if (res.data.demoted) {
					console.info('Esta oferta foi retirada para revisão.');
				}
			});
		}
	});
});
